import { CloseOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import classNames from 'classnames'
import telegramIcon from 'assets/icons/telegram.svg'
import { RoundedQrCode } from 'components/ui'
import styles from './BotConnectModal.module.scss'

type TBotMessenger = 'telegram' | 'max'

interface IBotConnectModalProps {
  open: boolean
  botUrl: string
  messenger: TBotMessenger
  onClose: () => void
}

interface IMessengerView {
  title: string
  buttonText: string
  buttonClassName: string
  icon?: string
}

const MESSENGERS: Record<TBotMessenger, IMessengerView> = {
  telegram: {
    title: 'Подключение Telegram-бота',
    buttonText: 'Открыть в Telegram',
    buttonClassName: styles.telegramButton,
    icon: telegramIcon
  },
  max: {
    title: 'Подключение MAX-бота',
    buttonText: 'Открыть в MAX',
    buttonClassName: styles.maxButton
  }
}

export const BotConnectModal: React.FC<IBotConnectModalProps> = ({
  open,
  botUrl,
  messenger,
  onClose
}) => {
  const { title, buttonText, buttonClassName, icon } = MESSENGERS[messenger]

  return (
    <Modal
      centered
      open={open}
      footer={null}
      closable={false}
      onCancel={onClose}
      width={360}
      // доп. затемнение фона под модалкой (как на сайте: rgba(0,0,0,0.5))
      maskStyle={{ background: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className={styles.body}>
        <button className={styles.close} onClick={onClose} aria-label='Закрыть'>
          <CloseOutlined />
        </button>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>
          Отсканируйте QR-код телефоном
          <br />
          или откройте бота на этом устройстве
        </p>
        <div className={styles.qrWrapper}>
          {/* Код рисуем из персональной ссылки: без токена в ней бот не поймёт,
              какой магазин подключают */}
          <RoundedQrCode value={botUrl} size={260} className={styles.qrImage} />
          {icon && (
            <span className={styles.qrLogo}>
              <img src={icon} alt='' className={styles.qrLogoIcon} />
            </span>
          )}
        </div>
        <a
          href={botUrl}
          target='_blank'
          rel='noopener noreferrer'
          className={classNames(styles.openButton, buttonClassName)}
          onClick={onClose}
        >
          {icon && <img src={icon} alt='' className={styles.buttonIcon} />}
          {buttonText}
        </a>
      </div>
    </Modal>
  )
}
